export const props = {
  // Values
  icon: String,

  // Status
  turn: Boolean,
  disabled: Boolean,

  // Options
  color: {
    type: String,
    default: 'basic',
    validator: value => [
      'basic',
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'error',
      'disabled',
      'black',
      'white',
      'medium'
    ].indexOf(value) !== -1
  },
  size: {
    type: String,
    validator: value => [
      'compact',
      'small',
      'medium',
      'large'
    ].indexOf(value) !== -1
  },
  background: Boolean
}
